export const lineHeight = {
  zero_3: '0.75',
  zero_4: '0.875rem',
  one: '1',
  one_1: '1.25',
  one_2: '1.5',
  one_3: '1.75',
  two: '2',
};
